/**
 * Challenge status constants for friend stats / pick history.
 * Use instead of magic strings when filtering or comparing status.
 */

export const CHALLENGE_STATUS = {
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;

export type ChallengeStatus = (typeof CHALLENGE_STATUS)[keyof typeof CHALLENGE_STATUS];

/** Map API status (lowercase) to CHALLENGE_STATUS for pick history entry. */
export const API_STATUS_TO_CHALLENGE_STATUS: Record<string, ChallengeStatus> = {
  completed: CHALLENGE_STATUS.COMPLETED,
  active: CHALLENGE_STATUS.ACTIVE,
  cancelled: CHALLENGE_STATUS.CANCELLED,
};

/** Fallbacks for pick history / match display when data is missing. */
export const BET_HISTORY_DISPLAY_FALLBACKS = {
  UNKNOWN: 'Unknown',
  CHALLENGE_NAME: 'Challenge',
} as const;
